import '@/global.css'
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { WithTranslation, withTranslation } from 'react-i18next';
import { requestCaptcha, resetPassword, sendResetPassword } from '@/services/generatedAPIs'
import { generateSalt, generateVerificationToken, hashPassword } from '@/lib/crypto'
import { Link, useLocation, useParams } from 'react-router'
import { ROUTE } from '@/routes/constants'
import globalStyles from './css/Global.module.css';
import { toast } from 'sonner'
import { TFunction } from 'i18next'

async function onAction(formData: FormData, token: string, t: TFunction) {
  const confirmPassword = formData.get("confirm-password") as string;
  const password = formData.get("password") as string;
  if (password !== confirmPassword) {
    return;
  }

  if (!token) {
    return;
  }

  const salt = generateSalt();
  const rsp = await resetPassword({
    token: token,
    salt: salt,
    password: hashPassword(password + salt),
  });
  if (rsp.code === 200) {
    toast(t('component.resetsuccess'));
  } else {
    toast(rsp.message);
  }
}

function ResetPassword({
  t,
  className,
  ...props
}: (React.ComponentProps<"form">) & WithTranslation) {
  const location = useLocation();
  
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  if (!token) {
    toast(t('component.tokenexception'));
  }

  return (
    <>
      <form className={cn("flex flex-col gap-6", className)} {...props} action={(formData: FormData) => onAction(formData, token!, t)}>
        <div className="flex flex-col items-center gap-2 text-center">
          <div className="text-4xl font-bold">{t('component.resetpwd')}</div>
        </div>
              <div className="grid gap-6 p-2 w-full">
                <div className="flex flex-row gap-2">
                  <Label className="flex-1" htmlFor="password">{t("user.password")}</Label>
                  <Input className='flex-3 invalid:border-red-500' id="password" name="password" type="password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$" onInvalid={(e: any) => { e.target.setCustomValidity(t("user.password-error")); }} onInput={(e: any) => { e.target.setCustomValidity(""); }} required />
                </div>

                <div className="flex flex-row gap-2">
                  <Label className="flex-1" htmlFor="confirm-password">{t("user.confirm-password")}</Label>
                  <Input className='flex-3 invalid:border-red-500' id="confirm-password" name="confirm-password" type="password" pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$" onInvalid={(e: any) => { e.target.setCustomValidity(t("user.password-error")); }} onInput={(e: any) => { e.target.setCustomValidity(""); }} required />
                </div>
              </div>

              <Button type="submit" className="w-full bg-gray-900 text-white hover:bg-gray-800">
                {t('component.confirmreset')}
              </Button>

      </form>

      <div className="text-center text-sm">
        <Link to={ROUTE.LOGIN} className={[globalStyles.textLink, "underline", "underline-offset-4","ml-1"].join(' ')}>
          {t("user.sign-in")}!
        </Link>
      </div>
    </>
  )
}

export default withTranslation()(ResetPassword);
